<div class="address-content">
    <p class="mb-0" *ngIf="address.line1">{{address.line1}}</p>
    <p class="mb-0" *ngIf="address.line2">{{address.line2}}</p>
    <p class="mb-0">{{address.postalCode}} - {{address.city}}</p>
    <p class="mb-0">{{address.district}} - {{address.country}}</p>
</div>